import _ from 'lodash';

export default function buildTagUrl(pathfinderWrapper, {type, key}) {

    const findPathById = _.curry((key, id) => pathfinderWrapper.pathfinder(key, { id }));
    const findCustomUrlPath = (custom_url) => '/'.concat(custom_url);

    const tagClassificationMapper = {
        search: (id) => pathfinderWrapper.pathfinder('search_gigs', null, { query: { query: id } }),
        tagPage: findPathById('gig_topics'),
        differentTag: findPathById('gig_topics'),
        category: findPathById('short_category'),
        subCategory: ({categorySlug, subCategorySlug}) => pathfinderWrapper.pathfinder('short_category_sub_category', {
            id: subCategorySlug,
            category_id: categorySlug
        }),
        skill: (skill) => pathfinderWrapper.pathfinder('skill', {skill}),
        customUrl: (id) => findCustomUrlPath(id)
    };

    return tagClassificationMapper[type](key);
}
